import { dreamOutcomeData } from "../data/mock";
import {
  Building2,
  BadgeDollarSign,
  ShieldCheck,
  Users,
  FileCheck,
  Plane,
  CalendarCheck,
  Globe,
} from "lucide-react";

const iconMap = {
  Building2,
  BadgeDollarSign,
  ShieldCheck,
  Users,
  FileCheck,
  Plane,
  CalendarCheck,
  Globe,
};

const HighlightText = ({ text, keyword }) => {
  if (!keyword) return text;
  const parts = text.split(keyword);
  if (parts.length < 2) return text;
  return (
    <>
      {parts[0]}
      <span className="text-[#dfddd6] font-semibold">{keyword}</span>
      {parts[1]}
    </>
  );
};

export const DreamOutcomeSection = () => {
  return (
    <section
      id="results"
      className="relative py-28"
      style={{ background: "#1a1c1b" }}
    >
      <div className="absolute top-0 left-0 right-0 h-px bg-[#3f4816]/30" />

      <div className="max-w-[87.5rem] mx-auto px-10">
        <div className="max-w-5xl">
          {/* Section Header */}
          <span
            className="inline-block text-[#888680] text-xs font-medium uppercase tracking-[0.2em] mb-5"
            style={{ fontFamily: "'Inter', Arial, sans-serif" }}
          >
            Dream Outcome
          </span>
          <h2
            className="font-black uppercase leading-[0.88] mb-14"
            style={{
              fontFamily: "'Inter', Arial, sans-serif",
              fontSize: "clamp(1.8rem, 1.4rem + 2vw, 3.2rem)",
              letterSpacing: "-0.02em",
            }}
          >
            <span className="text-[#dfddd6]">What </span>
            <span className="text-[#d9fb06]">"sorted"</span>
            <span className="text-[#dfddd6]"> actually looks like</span>
          </h2>

          {/* Outcomes — 2 column grid */}
          <div className="grid grid-cols-1 md:grid-cols-2 gap-3">
            {dreamOutcomeData.outcomes.map((outcome, i) => {
              const Icon = iconMap[outcome.icon];
              return (
                <div
                  key={i}
                  className="flex items-start gap-4 px-5 py-4 rounded-sm bg-[#302f2c]/25 border border-[#3f4816]/10 group hover:border-[#3f4816]/20 transition-colors duration-300"
                >
                  <div className="flex-shrink-0 w-8 h-8 rounded-md bg-[#3f4816]/12 border border-[#3f4816]/20 flex items-center justify-center group-hover:bg-[#3f4816]/20 transition-colors duration-300">
                    {Icon && <Icon size={14} className="text-[#d9fb06]" />}
                  </div>
                  <p
                    className="text-[#888680] text-sm leading-relaxed"
                    style={{ fontFamily: "'Inter', Arial, sans-serif" }}
                  >
                    <HighlightText text={outcome.text} keyword={outcome.keyword} />
                  </p>
                </div>
              );
            })}
          </div>
        </div>
      </div>
    </section>
  );
};
